module.exports = __webpack_public_path__ + "static/the-headspace-guide-to-mindfulness--meditation-1b09cb6ec49b9d0abc88dab62c2cd921.jpg";